import { createIdentifierStruct } from '@/modules/api/utils/jsonApiStructs';

import { customerMetricsResourceType } from './customerMetricsResourceConsts';

export const customerMetricsIdentifierStruct = createIdentifierStruct(
  customerMetricsResourceType
);
